import { render } from "./chef-list-page.vue?vue&type=template&id=62b0ad6e&scoped=true"
import script from "./chef-list-page.vue?vue&type=script&lang=js"
export * from "./chef-list-page.vue?vue&type=script&lang=js"

import "./chef-list-page.vue?vue&type=style&index=0&id=62b0ad6e&scoped=true&lang=scss"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b0ad6e"]])

export default __exports__